<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import AppButton from '@/components/atoms/buttons/AppButton.vue'
import AppDialog from '@/components/atoms/dialogs/AppDialog.vue'
import { usePauseCreateConfirmDialog } from '@/composables/usePauseCreateConfirmDialog'
import AppButtonIcon from '@/components/atoms/buttons/AppButtonIcon.vue'

const { t } = useI18n()
const { isVisible, acceptPauseCreation, rejectPauseCreation } = usePauseCreateConfirmDialog()

const visible = computed({
  get: () => isVisible.value,
  set: (value: boolean) => {
    if (!value) rejectPauseCreation()
  },
})
</script>

<template>
  <AppDialog
    v-model="visible"
    :header="t('pause.confirm_activate_title')"
    custom-class="backdrop-blur-xl!"
    width="min(92vw, 420px)"
    :draggable="false"
    :closable="false"
    :dismissableMask="false"
    :closeOnEscape="false"
  >
    <template #content>
      <div class="space-y-4">
        <div class="flex items-center gap-3">
          <span
            class="flex h-10 w-10 shrink-0 items-center shadow-sm justify-center rounded-full bg-amber-100 text-amber-600 dark:bg-amber-500/15 dark:text-amber-300"
          >
            <i class="pi pi-exclamation-triangle text-lg" />
          </span>
          <p class="text-sm leading-6 text-gray-700 dark:text-gray-200">
            {{ t('pause.confirm_activate_message') }}
          </p>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="flex w-full flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <AppButtonIcon
          :label="t('general.cancel')"
          severity="secondary"
          outlined
          class="w-full"
          :block="false"
          @click="rejectPauseCreation"
        />
        <AppButtonIcon
          :label="t('pause.confirm_activate_accept')"
          :block="false"
          class="w-full"
          @click="acceptPauseCreation"
        />
      </div>
    </template>
  </AppDialog>
</template>
